// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"46a39bf0","455":"d96ea5f3","977":"130d6061"}[chunkId] + ".chunk.js";
};